const OrderScanRestriction = ({ orderScanRestriction, setOrderScanRestriction, changeMerchantOrderScanRestriction }) => {

    return (
        <>
            <div className="row g-5 g-lg-10 mt-4">
                <div className="col p-0 mb-xl-10">
                    <h1 className="d-flex text-dark fw-bold m-0 fs-3 mb-5">
                        Order Scan Restriction
                    </h1>

                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="mb-1 fw-bold">Enable Order Scan Restriction</h5>
                                    <p className="text-muted mb-0">
                                        When enabled, an order assigned to another driver cannot be overridden, even if it is scanned.
                                    </p>
                                </div>

                                <div className="form-check form-switch form-check-custom form-check-solid">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="orderScanRestriction"
                                        checked={orderScanRestriction}
                                        onChange={(e) => {
                                            changeMerchantOrderScanRestriction(e.target.checked);
                                            setOrderScanRestriction(e.target.checked);
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="mt-4">
                                <span
                                    className={`badge ${orderScanRestriction ? "badge-light-success" : "badge-light-danger"
                                        }`}
                                >
                                    {orderScanRestriction ? "Enabled" : "Disabled"}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OrderScanRestriction;
